import { createLocaleTextHook } from '@moonpig/web-core-locale-text'

const dictionary = {
  info_link_title: {
    'en-GB': 'More info',
    'nl-NL': 'Meer informatie',
  },
}

export const useLocaleText = createLocaleTextHook({
  dictionary,
})
